export class testClass{
    testConsole(){
        console.log('======>test ts')
    }
}